import { createModel } from '@rematch/core'
import * as firebase from 'firebase'
import * as R from 'ramda'
import { dispatch, select, store } from '../store'

interface ILectureState {
  [lectureId: string]: ILecture
}

export default createModel({
  state: {} as ILectureState,
  reducers: {
    updateById: (
      state: ILectureState,
      payload: { lectureId: string; lecture: ILecture }
    ): ILectureState => ({
      ...state,
      [payload.lectureId]: payload.lecture
    })
  },
  effects: {
    async fetchLectures() {
      const lecturesRef = await firebase
        .firestore()
        .collection('lectures')
        .get()
      lecturesRef.docs.map(doc => {
        const lectureId = doc.id
        const lecture = doc.data() as ILecture
        dispatch.users.fetchUsers(lecture.speakerIds)
        this.updateById({ lectureId, lecture })
      })
    },
    async createLecture(lectureId: string) {
      const currentUser = firebase.auth().currentUser
      if (currentUser) {
        const lecture: ILecture = {
          title: '未命名講座',
          description: '這是一個最棒的講座！',
          photoURL: null,
          listPrice: 300,
          earlyPrice: 200,
          minEnrollment: 30,
          maxEnrollment: 50,
          soldAt: firebase.firestore.Timestamp.now(),
          startedAt: firebase.firestore.Timestamp.now(),
          endedAt: firebase.firestore.Timestamp.now(),
          tags: [],
          status: 'pending',
          units: [],
          speakerIds: [currentUser.uid],
          speakerInfo: {
            [currentUser.uid]: {
              title: '講者稱謂',
              description: '講者描述'
            }
          },
          estimatedDuration: 0,
          missions: [],
          targetAudiences: [],
          requirements: []
        }
        const ref = firebase
          .firestore()
          .collection('lectures')
          .doc(lectureId)
        const snapshot = await ref.get()
        if (snapshot.exists) {
          throw Error('Lecture ID exists')
        } else {
          return ref.set(lecture)
        }
      } else {
        throw Error('Please login first')
      }
    },
    async updateLecture(payload: {
      lectureId: string;
      updated: Partial<ILecture>;
    }) {
      const { lectureId, updated } = payload
      const lecture = select.lectures.getById(store.getState(), lectureId)
      const updatedLecture = {
        ...lecture,
        ...updated
      }
      firebase
        .firestore()
        .collection('lectures')
        .doc(lectureId)
        .set(updatedLecture)
      this.updateById({ lectureId, lecture: updatedLecture })
    }
  },
  selectors: {
    getById: (state: ILectureState, lectureId: string) => {
      return state[lectureId] ? state[lectureId] : null
    },
    getHotLectureIds: (state: ILectureState, num: number = 3) => {
      const lecturePayloads = R.filter(
        ({ lecture }) =>
          lecture.status === 'verified' &&
          lecture.endedAt.toDate() > new Date(),
        R.keys(state).map(lectureId => ({
          lectureId: lectureId as string,
          lecture: state[lectureId]
        }))
      ).map(({ lectureId }) => ({
        lectureId: lectureId as string,
        lectureStartedAt: state[lectureId].startedAt
      }))
      return R.take(
        num,
        R.sortBy(payload => payload.lectureStartedAt.toDate())(
          lecturePayloads
        ).map(payload => payload.lectureId)
      )
    },
    getVerifiedLectureIds: (state: ILectureState) => {
      return R.filter(
        ({ lecture }) => lecture.status === 'verified',
        R.keys(state).map(lectureId => ({
          lectureId: lectureId as string,
          lecture: state[lectureId]
        }))
      ).map(({ lectureId }) => lectureId)
    },
    getCreatedLectureIds: (state: ILectureState, userId?: string) => {
      const currentUser = firebase.auth().currentUser
      const speakerId = userId ? userId : currentUser ? currentUser.uid : null
      if (speakerId === null) {
        return []
      }
      const lecturePayloads = R.keys(state).map(lectureId => ({
        lectureId: lectureId as string,
        speakerIds: state[lectureId].speakerIds
      }))
      return R.filter(
        ({ speakerIds }) => R.contains(speakerId, speakerIds),
        lecturePayloads
      ).map(({ lectureId }) => lectureId)
    }
  }
})



// WEBPACK FOOTER //
// ./src/models/lectures.ts